
const SocketEvent = {
  //Socket消息事件
  GetReadyPatternDTO: "GetReadyPatternDTO",
  VideoProgressStatusDTO: "VideoProgressStatusDTO",
  // ScanCodeSuccessDTO: "ScanCodeSuccessDTO",
  ExitPatternSyncDTO: "ExitPatternSyncDTO",
  StartWatchVideoStatusDTO: "StartWatchVideoStatusDTO",
  StopWatchVideoStatusDTO: "StopWatchVideoStatusDTO",
  PcExitPatternSyncDTO: "PcExitPatternSyncDTO",
  RemoteSyncStatusDTO: "RemoteSyncStatusDTO",
  GetSyncStatusDTO: "GetSyncStatusDTO",
  StartPreviewModeDTO: "StartPreviewModeDTO",
  GetVideoProgressDTO: "GetVideoProgressDTO",
  ModifyVideoPatternDTO: "ModifyVideoPatternDTO",
  ErrorSyncPatternDTO: "ErrorSyncPatternDTO",
  SuccessDownloadPatternDTO: "SuccessDownloadPatternDTO",
  RetrySyncPatternDTO: "RetrySyncPatternDTO",
  DisconnectPatternSyncDTO: "DisconnectPatternSyncDTO",
  SyncPatternStatusChangeDTO: "SyncPatternStatusChangeDTO",
  SocketDisconnectDTO: "SocketDisconnectDTO",
  VideoPreviewStatusDTO: "VideoPreviewStatusDTO",

  //普通消息事件
  SetPlaySpeedDTO: "SetPlaySpeedDTO",
}

export default SocketEvent;